<template>
    <div class="d-block" :class="stacked ? null : 'd-lg-flex align-items-center'">

        <div :style="`width:${iconSize}px; height:${iconSize}px;`" :class="stacked ? 'mb-3' : 'me-3 mb-3 mb-lg-0'">
            <marquis-circle-icon class="text-primary"/>
        </div>

        <hgroup class="text-light-primary">
            <h4 class="mb-0">Properties within the Marquis Collection are managed and supported by StayMarquis,</h4>
            <h4><em>ensuring an unmatched level of trust, care, and convenience.</em></h4>
        </hgroup>

    </div>
</template>

<script type="text/javascript">
    import MarquisCircleIcon from '@/assets/logos/marquis-circle-icon.svg.vue';

    import CommonComponents from '@/components/Common.vue';


    export default {
        components: {
            MarquisCircleIcon,
            ...CommonComponents,
        },

        props: {

            stacked: {
                type: Boolean,
                default: false,
            },

            iconSize: {
                type: Number,
                default: 48,
            }
        },
    };

</script>
